<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :visible="visible"
    @close="handleEditDialogClose"
    style="overflow: hidden"
    top="20px"
    width="65%"
  >
    <div style="overflow-y: auto; height: 70vh">
      <el-form
        :model="formData"
        label-width="124px"
        :rules="formRule"
        ref="form"
        size="mini"
        class="locale-form"
      >
        <el-row class="form-part">
          <el-col :span="2" class="form-part-title">
            <div class="wordWrapClass">基本信息</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="locale_type" label="监测类型">
              <el-select :disabled="isView" v-model="formData.locale_type" @change="selectChange" placeholder="请选择监测类型">
                <el-option
                  v-for="item in localeTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="contact" label="联系人">
              <el-input
                @change="hasChange"
                v-model.trim="formData.contact"
                placeholder="请输入联系人"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="addr" label="详细地址">
              <el-input
                @change="hasChange"
                placeholder="请输入详细地址"
                v-model.trim="formData.addr"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="area_id" label="所属地区">
              <el-cascader
                style="width: 100%"
                placeholder="关键字"
                v-model.trim="formData.area_id"
                @change="hasChange"
                :options="areaTree"
                :props="areaProps"
                filterable
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_length" label="集气罩长">
              <el-input
                @change="hasChange"
                placeholder="请输入集气罩长(m)"
                v-model="formData.stove_length"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_area" label="集气灶面积">
              <el-input
                @change="hasChange"
                placeholder="请输入集气灶面积(m²)"
                v-model="formData.stove_area"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="cuisine" label="选择菜系">
              <el-cascader
                :disabled="isView"
                v-model="formData.cuisine"
                :options="cuisine"
                @change="hasChange"></el-cascader>
            </el-form-item>
            <el-form-item prop="scale" label="企业类型">
              <el-select
                style="width: 100%"
                @change="hasChange"
                placeholder="请选择企业类型"
                v-model.trim="formData.scale"
                :disabled="isView"
              >
                <el-option value="大" label="大"/>
                <el-option value="中" label="中"/>
                <el-option value="小" label="小"/>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formData.locale_type === 10"
              prop="is_check"
              label="是否有检修平台">
              <el-select
                style="width: 100%"
                placeholder="请选择是否有检修平台"
                @change="changeRepairPlatform"
                v-model="formData.is_check"
                :disabled="isView">
                <el-option :value= 0 label="否"/>
                <el-option :value= 1 label="是"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="maintainer_id" label="维保人员">
              <el-select
                style="width: 100%"
                @change="hasChange"
                placeholder="请选择维保人员"
                v-model="formData.maintainer_id"
                :disabled="isView">
                <el-option v-for="item in maintenanceList"
                           :key="item.Id"
                           :value="item.Id"
                           :label="item.Name"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="bl_no" label="营业执照名称">
              <el-input
                @change="hasChange"
                placeholder="请输入营业执照名称"
                :disabled="isView"
                v-model.trim="formData.bl_name"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="name" label="监测点名称">
              <el-input
                placeholder="请输入监测点名称"
                @change="hasChange"
                v-model.trim="formData.name"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="mobile" label="联系电话">
              <el-input
                @change="hasChange"
                v-model.trim="formData.mobile"
                placeholder="请输入联系电话"
                :disabled="isView"/>
            </el-form-item>
            <el-form-item prop="owner" label="所属单位">
              <el-cascader
                style="width: 100%"
                placeholder="关键字"
                v-model.trim="formData.owner"
                @change="handleOwnerChange"
                :options="customerTree"
                :props="props"
                filterable
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_width" label="集气罩宽">
              <el-input
                @change="hasChange"
                placeholder="请输入集气罩宽"
                v-model="formData.stove_width"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="exhaust_time" label="日均排烟时间">
              <el-input
                @change="hasChange"
                placeholder="请输入日均排烟时间(h)"
                v-model.trim="formData.exhaust_time"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="stove_num" label="基准灶头数">
              <el-input
                @change="hasChange"
                placeholder="请输入基准灶头数"
                v-model="formData.stove_num"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="management_types" label="经营类型">
              <el-cascader
                :disabled="isView"
                v-model="formData.management_types"
                :options="managementTypes"
                @change="hasChange"></el-cascader>
            </el-form-item>
            <el-form-item prop="bl_no" label="营业执照号">
              <el-input
                @change="hasChange"
                placeholder="请输入营业执照号"
                :disabled="isView"
                v-model.trim="formData.bl_no"
              />
            </el-form-item>
            <el-form-item prop="lng" label="经度">
              <el-input
                @change="hasChange"
                placeholder="可直接粘贴到此处"
                v-model.trim="formData.lng"
                @keyup.ctrl.86.native="handlePaste"
                :disabled="isView"
              />
            </el-form-item>
            <el-form-item prop="lat" label="纬度">
              <el-input
                @change="hasChange"
                v-model.trim="formData.lat"
                :disabled="isView"/>
            </el-form-item>
            <a style="color: #409eff; text-decoration: none; margin-left: 120px;font-size:12px;"
              target="_blank"
              v-if="!isView"
              href="https://api.map.baidu.com/lbsapi/getpoint/index.html">
              百度坐标拾取系统
            </a>
          </el-col>
        </el-row>
        <el-row class="form-part">
          <el-col :span="2" class="form-part-title">
            <div class="wordWrapClass">排放系统信息</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="fan_factory_name" label="风机品牌">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_factory_name"
                :disabled="isView"
                placeholder="请输入风机品牌"/>
            </el-form-item>
            <el-form-item prop="fan_power" label="风机功率">
              <el-input
                @change="hasChange"
                v-model="formData.fan_power"
                :disabled="isView"
                placeholder="请输入风机功率(kW)"/>
            </el-form-item>
            <el-form-item prop="fan_speed" label="烟气流速">
              <el-input
                @change="hasChange"
                v-model="formData.fan_speed"
                :disabled="isView"
                placeholder="请输入风机功率(m/s)"/>
            </el-form-item>
            <el-form-item prop="filter_factory_name" label="净化器品牌">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_factory_name"
                :disabled="isView"
                placeholder="请输入净化器品牌"/>
            </el-form-item>
            <el-form-item prop="purifying_rate" label="净化器净化率">
              <el-input
                @change="hasChange"
                v-model="formData.purifying_rate"
                :disabled="isView"
                placeholder="请输入净化器净化率"/>
            </el-form-item>
            <el-form-item prop="filter_power" label="净化器功率">
              <el-input
                @change="hasChange"
                v-model="formData.filter_power"
                :disabled="isView"
                placeholder="请输入净化器功率(kW)"/>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item prop="fan_factory_model_id" label="风机型号">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_factory_model_id"
                :disabled="isView"
                placeholder="请输入风机型号"/>
            </el-form-item>
            <el-form-item prop="fan_standard_current" label="风机标准电流">
              <el-input
                @change="hasChange"
                v-model="formData.fan_standard_current"
                :disabled="isView"
                placeholder="请输入风机标准电流(A)"/>
            </el-form-item>
            <el-form-item prop="pipe_area" label="管道截面积">
              <el-input
                @change="hasChange"
                v-model="formData.pipe_area"
                :disabled="isView"
                placeholder="请输入管道截面积(m²)"/>
            </el-form-item>
            <el-form-item prop="filter_factory_model_id" label="净化器型号">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_factory_model_id"
                :disabled="isView"
                placeholder="请输入净化器型号"/>
            </el-form-item>
            <el-form-item prop="fan_quantity" label="净化器风量">
              <el-input
                @change="hasChange"
                v-model="formData.fan_quantity"
                :disabled="isView"
                placeholder="请输入净化器风量(m³/h)"/>
            </el-form-item>
            <el-form-item prop="filter_standard_current" label="净化器标准电流">
              <el-input
                @change="hasChange"
                v-model="formData.filter_standard_current"
                :disabled="isView"
                placeholder="请输入净化器标准电流(A)"/>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="formData.type == 1">
        <el-row class="form-part">
          <el-col :span="2" class="form-part-title">
            <div class="wordWrapClass">监测仪信息</div>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="voc_factory_name" label="监测仪品牌">
              <el-select
                style="width: 100%"
                @change="handleFactorySelect"
                v-model.trim="formData.voc_factory_name"
                :disabled="isView"
                placeholder="请选择监测仪品牌">
                <el-option v-for="factory in factoryList"
                           :key="factory.factory_name"
                           :label="factory.factory_name"
                           :value="factory.factory_name"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="principle" label="检测原理">
              <el-select
                @change="hasChange"
                v-model.trim="formData.principle"
                :disabled="isView"
                placeholder="请输入检测原理"
                style="width: 100%">
                <el-option value="光散射" label="光散射"/>
                <el-option value="电化学" label="电化学"/>
                <el-option value="其他" label="其他"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="power_supply_mode" label="接电方式">
              <el-select
                @change="hasChange"
                v-model.trim="formData.power_supply_mode"
                :disabled="isView"
                placeholder="请输入接电方式"
                style="width: 100%">
                <el-option value="风机取电" label="风机取电"/>
                <el-option value="净化器取电" label="净化器取电"/>
                <el-option value="市电" label="市电"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="fan_mn" label="风机监控编码" v-if="this.formData.send_mode===2 ||(this.formData.send_mode===3 &&this.formData.power_supply_mode ==='净化器取电')">
              <el-input
                @change="hasChange"
                v-model.trim="formData.fan_mn"
                :disabled="isView"
                placeholder="请输入风机监控编码后8位后进行补全">
                <div slot="append" @click="addPrefix('风机')">补全</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="voc_factory_model_id" label="监测仪型号">
              <el-select
                style="width: 100%"
                @change="hasChange"
                v-model.trim="formData.voc_factory_model_id"
                :disabled="isView"
                placeholder="请选择监测仪型号">
                <el-option v-for="item in factoryModelList"
                           :key="item.id"
                           :value="item.id"
                           :label="item.model_name"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="send_mode" label="传输方式">
              <el-select
                @change="hasChange"
                v-model="formData.send_mode"
                :disabled="isView"
                placeholder="请输入传输方式"
                style="width: 100%">
                <el-option :value="1" label="合并传输"/>
                <el-option :value="2" label="独立传输"/>
                <el-option :value="3" label="两路传输"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="voc_mn" label="监测仪编码">
              <el-input
                @change="hasChange"
                v-model.trim="formData.voc_mn"
                :disabled="isView"
                placeholder="请输入监测仪编码后8位后进行补全">
                <div slot="append" @click="addPrefix('监测仪')">补全</div>
              </el-input>
            </el-form-item>
            <el-form-item prop="filter_mn" label="净化器监控编码" v-if="this.formData.send_mode===2 ||(this.formData.send_mode===3 &&this.formData.power_supply_mode ==='风机取电') ||(this.formData.send_mode===3 &&this.formData.power_supply_mode ==='市电')">
              <el-input
                @change="hasChange"
                v-model.trim="formData.filter_mn"
                :disabled="isView"
                placeholder="请输入净化器监控编码后8位后进行补全">
                <div slot="append" @click="addPrefix('净化器')">补全</div>
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        </template>
       <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">
              营业执照图片
              <!-- <span style="color:#ff0000;">*</span> -->
            </div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 1)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 1"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 1).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">店铺门头图片<span style="color:#ff0000;">*</span></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 2)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 2"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 2).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">灶头整体图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 3)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 3"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 3).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">集烟罩图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 4)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 4"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 4).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">风机图片</div>
             <span style="color:#ff0000;" v-if="formData.locale_type === 2">*</span>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 5)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 5"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 5).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">净化器图片</div>
            <span style="color:#ff0000;" v-if="formData.locale_type === 2 || (formData.locale_type === 10 && formData.is_check === 1)">*</span>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 6)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 6"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 6).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">监测仪图片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 7)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 7"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 7).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part">
          <el-col :span="6" class="form-part-title">
            <div style="text-align: center;letter-spacing: 3px;font-weight: bold;">其他照片</div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <el-upload
                ref="upload"
                accept=".jpg,.jpeg,.png"
                :show-file-list="false"
                :action="upload()"
                :on-success="(response, file, fileList) => { return handleAvatarSuccess(response, file, fileList, 8)}"
                :before-upload="hasChange"
                v-if="!isView"
              >
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip">（支持jpg、jpeg、png）</div>
              </el-upload>
              <div class="img-list" v-if="fileList.length">
                <div class="single-img" v-for="(item, idx) in fileList" :key="idx" v-if="item.type == 8"
                     style="position: relative; display: inline-block; margin-right: 10px;">
                  <el-image
                    style="width: 100px;height: 100px"
                    :src="item.pic"
                    :preview-src-list="fileList.filter(f => f.type == 8).map(f => f.pic)"
                    fit="fit"/>
                  <div v-if="!isView" class="remove-img el-icon-close" @click="removeImg(idx)"></div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-part" v-if="isView && title ==='审核'">
          <el-col :span="8">
            <el-form-item label="审核结果">
              <el-select
                @change="hasChange"
                v-model="status">
                <el-option :value="1" label="通过"/>
                <el-option :value="2" label="不通过"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              label="原因">
              <el-input
                @input="hasChange"
                v-model="formData.remark"
                placeholder="请输入原因"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer" v-if="title!=='查看'">
      <el-button size="mini" @click.native="handleClose"
      >取消
      </el-button
      >
      <el-button type="primary" size="mini" @click.native="handleSubmit"
      >提交
      </el-button
      >
    </div>
  </el-dialog>
</template>
<script>

import conf from "@/config";
import {mapState} from "vuex";
import {getUserInfo, join, ownerJoin} from "@/util";

export default {
  name: "LocaleVerifyEditDialog",
  props: ['title', 'visible', 'state', 'formData', 'isView', 'cuisine', 'managementTypes'],
  computed: {
    ...mapState(['areaTree', 'clientHeight', 'locale', 'customerTree','customer']),
    ...mapState({
      props: (state) => Object.assign({}, state.props, {label: 'Org', checkStrictly: true}),
      customerProps: (state) =>
        Object.assign({}, state.props, {label: 'Org', checkStrictly: true}),
      selAreaProps: (state) =>
        Object.assign({}, state.props, {checkStrictly: true}),
      areaProps: (state) => Object.assign({}, state.props)
    })
  },
  data() {
    return {
      userInfo: '',
      changeState: false,
      fileList: [],
      formRule: {
        maintainer_id: [{required: true, message: '维保人员不可为空', trigger: 'blur'}],
        name: [{required: true, message: '名称不可为空', trigger: 'blur'}],
        contact: [{required: true, message: '联系人不可为空', trigger: 'blur'}],
        addr: [{required: true, message: '详细地址不可为空', trigger: 'blur'}],
        mobile: [{required: true, message: '联系电话不可为空', trigger: 'blur'},{ pattern: /^([1-9][0-9]*)$/, message: '请输入正确额格式' }],
        lng: [{required: true, message: '经度不可为空', trigger: 'blur'}],
        lat: [{required: true, message: '纬度不可为空', trigger: 'blur'}],
        area_id: [{required: true, message: '所属地区不可为空', trigger: 'blur'}],
        owner: [{required: true, message: '所属单位不可为空', trigger: 'blur'}],
        stove_area: [{required: true, message: '集气罩面积不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        exhaust_time: [{required: true, message: '日均排烟时间不可为空', trigger: 'blur'},{ pattern: /^([1-9][0-9]*)$/, message: '请输入正确额格式' }],
        cuisine: [{required: true, message: '菜系不可为空', trigger: 'blur'}],
        stove_num: [{required: true, message: '基准灶头数不可为空', trigger: 'blur'},{ pattern: /^([1-9][0-9]*)$/, message: '请输入正确额格式' }],
        scale: [{required: true, message: '企业类型不可为空', trigger: 'blur'}],
        management_types: [{required: true, message: '经营类型不可为空', trigger: 'blur'}],
        fan_standard_current: [{required: true, message: '风机标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        filter_standard_current: [{required: true, message: '净化器标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        voc_factory_name: [{required: true, message: '监测仪品牌不可为空', trigger: 'blur'}],
        principle: [{required: true, message: '检测原理不可为空', trigger: 'blur'}],
        power_supply_mode: [{required: true, message: '接电方式不可为空', trigger: 'blur'}],
        voc_factory_model_id: [{required: true, message: '监测仪型号不可为空', trigger: 'blur'}],
        send_mode: [{required: true, message: '传输方式不可为空', trigger: 'blur'}],
        voc_mn: [{required: true, message: '监测仪编码', trigger: 'blur'}],
        locale_type: [{required: true, message: '监测点类型不能为空', trigger: 'blur'}],
        fan_power:[{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        fan_speed:[{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        purifying_rate:[{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        pipe_area: [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        stove_length: [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
        stove_width: [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }],
      },
      factoryList: [],
      factoryModelList: [],
      maintenanceList: [],
      localeTypes:[{id:2,name:'监测类'},{id:10,name:'非监测类'}],
      status: null
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    "formData.is_check": {
      handler: function (val) {
        this.selectChange()
      }
    },
    "formData.type": {
      handler: function (val) {
        this.selectChange()
      }
    },
    "formData.locale_exam_pics": {
      handler: function (val) {
        if (val) {
          this.fileList = this.formData.locale_exam_pics
        } else {
          this.fileList = []
        }
      }
    },
    "formData.voc_factory_name": {
      handler: function (val) {
        let param = {
          StartAt: 0,
          Size: 20,
          Param:
            {
              FactoryName: val,
              ModelType: 1
            }
        }
        this.$post('admin/listFactoryModel', param).then(res => {
          this.factoryModelList = res.content
        })
      }
    }
  },
  methods: {
    //补全监测仪编码、净化器监控编码、风机监控编码  监测仪补F0 监控补D0
    addPrefix(type) {
      if (type === '监测仪') { // 此时补全监测仪
        if (this.formData.voc_mn.includes('010000A8900016F0')) {
          this.$message({
            message: '您已补全监测仪设备编码！',
            type: 'warning'
          });
          return;
        }
        if (this.formData.voc_mn.length !== 8) { // 当设备为8位的时候才能补全
          this.$message({
            message: '请输入监测仪设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
        this.formData.voc_mn = '010000A8900016F0' + this.formData.voc_mn;
      } else if (type === '净化器') {
        if (this.formData.filter_mn.includes('010000A8900016D0')) {
          this.$message({
            message: '您已补全净化器设备编码！',
            type: 'warning'
          });
          return;
        }
        if (this.formData.filter_mn.length !== 8) { // 当设备为8位的时候才能补全
          this.$message({
            message: '请输入净化器设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
        this.formData.filter_mn = '010000A8900016D0' + this.formData.filter_mn;
      } else if (type === '风机') {
        if (this.formData.fan_mn.includes('010000A8900016D0')) {
          this.$message({
            message: '您已补全风机设备编码！',
            type: 'warning'
          });
          return;
        }
        if (this.formData.fan_mn.length !== 8) { // 当设备为8位的时候才能补全
          this.$message({
            message: '请输入风机设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
        this.formData.fan_mn = '010000A8900016D0' + this.formData.fan_mn;
      }
      // 触发表单变化事件
      this.hasChange();
    },
    init() {
      const user = getUserInfo()
      this.userInfo = user.Info
      this.$post('admin/listFactory', {}).then(res => {
        this.factoryList = res.content
      })
      this.$get("admin/listMaintainer").then((res) => {
        this.maintenanceList = res;
      });
    },
    selectChange(){
      if (this.formData.locale_type == 2) {
        this.formData.type = 1
      } else {
        this.formData.type = 2
      }
      if (this.formData.type == 1) {
        // 监测类的验证规则
        this.formRule.maintainer_id = [{required: true, message: '维保人员不可为空', trigger: 'blur'}]
        this.formRule.stove_area = [{required: true, message: '集气罩面积不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.exhaust_time = [{required: true, message: '日均排烟时间不可为空', trigger: 'blur'}]
        this.formRule.cuisine = [{required: true, message: '菜系不可为空', trigger: 'blur'}]
        this.formRule.fan_standard_current = [{required: true, message: '风机标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.filter_standard_current = [{required: true, message: '净化器标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.voc_factory_name = [{required: true, message: '监测仪品牌不可为空', trigger: 'blur'}]
        this.formRule.principle = [{required: true, message: '检测原理不可为空', trigger: 'blur'}]
        this.formRule.power_supply_mode = [{required: true, message: '接电方式不可为空', trigger: 'blur'}]
        this.formRule.voc_factory_model_id = [{required: true, message: '监测仪型号不可为空', trigger: 'blur'}]
        this.formRule.send_mode = [{required: true, message: '传输方式不可为空', trigger: 'blur'}]
        this.formRule.voc_mn = [{required: true, message: '监测仪编码', trigger: 'blur'}]
      } else {
        // 非监测类的验证规则
        this.formRule.stove_area = [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.exhaust_time = []
        this.formRule.cuisine = []
        this.formRule.maintainer_id = []
        this.formRule.fan_standard_current = [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        this.formRule.principle = []
        this.formRule.power_supply_mode = []
        this.formRule.send_mode = []
        // 根据是否有检修平台设置净化器标准电流的验证规则
        if(this.formData.is_check === 1) {
          // 有检修平台时，设置为必填
          this.formRule.filter_standard_current = [{required: true, message: '净化器标准电流不可为空', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        } else {
          // 无检修平台时，不删除规则，而是设置为非必填但保留格式验证
          this.formRule.filter_standard_current = [{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' }]
        }
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate([
          'maintainer_id','stove_area', 'exhaust_time', 'cuisine',
          'fan_standard_current','filter_standard_current',
          'principle','power_supply_mode','send_mode'
        ]);
      });
    },
    handleEditDialogClose: function () {
      if (this.changeState) {
        this.changeState = false
      }
      this.handleClose()
    },
    changeRepairPlatform(){
      this.changeState = true
      this.selectChange()
    },
    hasChange() {
      this.changeState = true
    },
    handlePaste() {
      this.changeState = true
      const arr = this.formData.lng.split(',')
      this.formData.lng = arr[0]
      this.formData.lat = arr[1]
    },
    handleOwnerChange(v) {
      this.changeState = true
    },
    /**
     * 监测仪品牌选择后调用
     * @param value
     */
    handleFactorySelect(value) {
      this.changeState = true
      this.formData.voc_factory_model_id = ""
      let param = {
        StartAt: 0,
        Size: 20,
        Param:
          {
            FactoryName: value,
            ModelType: 1
          }
      }
      this.$post('admin/listFactoryModel', param).then(res => {
        this.factoryModelList = res.content
      })
    },

    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    removeImg(idx) {
      this.changeState = true
      this.fileList.splice(idx, 1)
    },
    handleAvatarSuccess(res, file, fileList, type) {
      this.fileList.push({pic:res.Data, type: type})
    },
    handleSubmit() {
      if (!this.changeState && this.title !== '审核') {
        this.$emit("handleClose")
        return
      }

      // var managePics = []
      var shopPic = []
      // var stovePic = []
      // var areaPic = []
      var fanPic = []
      var filterPic = []
      // var vocPic = []
      for(var i = 0; i < this.fileList.length; i ++) {
        // if (this.fileList[i].type == 1) {
        //   managePics.push(this.fileList[i].pic)
        // }
        if (this.fileList[i].type == 2) {
          shopPic.push(this.fileList[i].pic)
        }
      //   if (this.fileList[i].type == 3) {
      //     stovePic.push(this.fileList[i].pic)
      //   }
      //   if (this.fileList[i].type == 4) {
      //     areaPic.push(this.fileList[i].pic)
      //   }
        if (this.fileList[i].type == 5) {
          fanPic.push(this.fileList[i].pic)
        }
        if (this.fileList[i].type == 6) {
          filterPic.push(this.fileList[i].pic)
        }
      //   if (this.fileList[i].type == 7) {
      //     vocPic.push(this.fileList[i].pic)
      //   }
      }
      if (this.title === '新增' || this.title === '编辑') {
        // if (managePics.length == 0) {
        //   this.$message({
        //     message: '营业执照图片不能为空',
        //     type: 'info'
        //   });
        //   return
        // }

        if (shopPic.length == 0) {
          this.$message({
            message: '店铺门头图片不能为空',
            type: 'info'
          });
          return
        }
        if(this.formData.locale_type === 2){//此时是监测点，风机和净化器都要必填
          if (fanPic.length == 0) {
            this.$message({
              message: '风机图片不能为空',
              type: 'info'
            });
            return
          }
          if (filterPic.length == 0) {
            this.$message({
              message: '净化器图片不能为空',
              type: 'info'
            });
            return
          }
        }else {
          if(this.formData.is_check === 1){//选择了有监测平台，净化器电流值、净化器图片必填
            if (filterPic.length == 0) {
              this.$message({
                message: '净化器图片不能为空',
                type: 'info'
              });
              return
            }
          }
        }
      }
      // if (stovePic.length == 0) {
      //   this.$message({
      //     message: '灶头整体图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (areaPic.length == 0) {
      //   this.$message({
      //     message: '集烟罩图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (fanPic.length == 0) {
      //   this.$message({
      //     message: '风机图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (filterPic.length == 0) {
      //   this.$message({
      //     message: '净化器图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      // if (vocPic.length == 0) {
      //   this.$message({
      //     message: '监测仪图片不能为空',
      //     type: 'info'
      //   });
      //   return
      // }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              if(this.formData.locale_type === 2){//监测类的时候删除is-check字段
                this.$delete(this.formData, 'is_check')
              }
              const para = Object.assign({}, this.formData)
              let userInfo = getUserInfo().Info
              para.owner = ownerJoin(this.formData.owner, userInfo)
              para.area_id = join(para.area_id)
              if (this.fileList.length > 0) {
                para.pics = JSON.stringify(this.fileList)
              }
              let param = new URLSearchParams()
              Object.entries(para).forEach(([key, val]) => {
                if (key == 'cuisine') {
                  if (val && val.length > 1) {
                    param.append(key, val[1])
                  } else {
                    if (this.formData.type == 1) {
                      this.$message({
                        message: '菜系选择有误',
                        type: 'info'
                      });
                      return false
                    }
                  }
                } else if (key == 'management_types') {
                  if (val.length > 1) {
                    param.append(key, val[1])
                  } else {
                    this.$message({
                      message: '经营类型选择有误',
                      type: 'info'
                    });
                    return
                  }
                } else {
                  param.append(key, val)
                }
              })
              if (this.title === '新增') {
                this.$post('admin/locale_exam/add', param).then(res => {
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  this.$emit("handleClose")
                })
              } else if (this.title === '编辑') {
                param.set('status', 0)
                this.$post('admin/locale_exam/edit/' + this.formData.id, param).then(res => {
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  this.$emit("handleClose")
                })
              } else if (this.title === '审核') {
                if (!this.status && this.status === null) {
                  this.$message({
                    message: '请选择是否审核通过',
                    type: 'info'
                  });
                  return
                }
                param.set('status', this.status)
                if(this.formData.remark !== '' && this.formData.remark !== undefined){
                  param.set('remark', this.formData.remark)
                }
                this.$post('admin/locale_exam/edit/' + this.formData.id, param).then(res => {
                  this.$message({
                    message: '审核成功',
                    type: 'success'
                  });
                  this.$emit("handleClose")
                })
              }

            })

        }
      })
    },
    handleClose() {
      this.fileList = []
      this.$emit("handleClose")
    }
  }
}
</script>
<style scoped lang="scss">
.form-part {
  display: flex;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  border-color: #eeeeee;
}

.form-part-title {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #EBEEF5
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.single-img > img {
  width: 100px;
  height: 100px;
}


.wordWrapClass {
  vertical-align: center;
  writing-mode: vertical-lr;
  text-align: center;
  letter-spacing: 6px;
  font-weight: bold;
}
//给监测仪编码补全设置的样式
/deep/ .el-input-group__append, .el-input-group__prepend {
  font-style: normal !important;
  padding: 0px 8px 0px 8px !important;
  cursor: pointer !important;
}
</style>
